module.exports = __webpack_public_path__ + "media/images/weather/402_day-aafd1036f4e712b0a8e13806c15c0c62.png";